module.exports = "<nv-react-component component=\"ReactAngularColorPicker\" dispatch-store-updates=\"false\"></nv-react-component>";